import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FuseConfigService } from '@fuse/services/config.service';
import { Configuration } from 'app/app.configuration';
import { DataService } from 'app/shared/common/helper/http-service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-register-admin',
  templateUrl: './register-admin.component.html',
  styleUrls: ['./register-admin.component.scss']
})
export class RegisterAdminComponent implements OnInit {
  loginForm: FormGroup;
  loginFormErrors: any;
  hide = true;
  isDesktopAppVisible: boolean;
  selectedCustomerForm: FormGroup;


  constructor(
    private _formBuilder: FormBuilder,
    private _fuseConfigService: FuseConfigService,
    private configuration: Configuration,
    private dataService: DataService,
    private toastr: ToastrService,
    private router: Router
  ) {

    this._fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        toolbar: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        sidepanel: {
          hidden: true
        }
      }
    };
  }

  onSubmit() {
    console.log('hi');
  }
  ngOnInit(): void {
    this.selectedForm();
  }

  selectedForm() {
    const emailRegEx = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
    this.selectedCustomerForm = this._formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.pattern(emailRegEx)]],
      company: ['' , Validators.required]
    });
  }

  customerOnboarding() {
    if (!this.selectedCustomerForm.valid) {
      return;
    }
    const data = {
      toEmail: this.selectedCustomerForm.value.email,
      firstName: this.selectedCustomerForm.value.firstName,
      lastName: this.selectedCustomerForm.value.lastName,
      companyName: this.selectedCustomerForm.value.company,
      sourceFrom: 'Web'
    };

    this.dataService.add(this.configuration.customerOnboarding, data).subscribe((data: any) => {
      if (data.isSuccess) {
        this.toastr.success('Register successfully');
        this.selectedCustomerForm.reset();
        this.router.navigate(['/login']);
      } else {
        this.toastr.error(data.message);
      }
    }, error => {
      console.log('error', error);
    });
  }

}
